/* polyfills */
import 'babel-polyfill';
import 'whatwg-fetch';
import './polyfill-nodelist-foreach';

/* modules */
import './utils';
import './lazy-img';
import './font-load';
import './modal';

/* async modules */
import(/* webpackChunkName: "carousels" */ './carousels');
import(/* webpackChunkName: "mobile-menu" */ './mobile-menu');
import(/* webpackChunkName: "search" */ './search');
import(/* webpackChunkName: "accordions" */ './accordions');
import(/* webpackChunkName: "modal-imgload" */ './modal-imgload');
import(/* webpackChunkName: "modal-html-node-load" */ './modal-html-node-load');
import(/* webpackChunkName: "scroll-top" */ './scroll-top');
import('./video');

if (document.querySelector('.map-container')) {
  import(/* webpackChunkName: "map" */ './map');
}

if (document.querySelector('.contact-form')) {
  import(/* webpackChunkName: "contact" */ './contact');
}

if (document.querySelector('.career-form')) {
  import(/* webpackChunkName: "career" */ './career-form');
}

if (document.querySelector('.newsletter-form')) {
  import(/* webpackChunkName: "contact" */ './newsletter');
}

if (document.querySelector('.material-filter')) {
  import(/* webpackChunkName: "material-filter" */ './material-filter');
  import(/* webpackChunkName: "tab-switch" */ './tab-switch');
}

if (document.querySelector('.item-typology')) {
  import(/* webpackChunkName: "typology-item-dropdown" */ './typology-item-dropdown');
}

if (document.querySelector('.more-marker')) {
  import(/* webpackChunkName: "load-more" */ './load-more');
}

if (document.querySelector('.js-collection-filter')) {
  import('./professional-filter');
}

if (document.querySelector('.js-market-filter')) {
  import(/* webpackChunkName: "market-filter" */ './market-filter');
}

if (!localStorage.getItem('cookies-read')) {
  import(/* webpackChunkName: "cookiebar" */ './cookiebar');
}

if (document.querySelector('.career')) {
  import(/* webpackChunkName: "careers" */ './careers');
}

if (document.querySelector('#is-video-text-white')) {
  import(/* webpackChunkName: "videomeuhotfix" */ './video-menu-hotfix');
}


// WEBPACK FOOTER //
// ./src/js/app.js